import { Account, FeaturesSchema } from './Navigator.type';
import { featuresSchema } from './Navigator.schema';

export class NavigatorMap {
  static filterAndSortFeatures(account: Account): string[] {
    const { features } = account;
    let featuresFiltered = [...(features || []), 'finance', 'settings'];
    
    // Adicionar filiais e users se não estiverem nas features da conta
    if (!account.features?.includes('filials')) {
      featuresFiltered.push('filials');
    }
    if (!account.features?.includes('users')) {
      featuresFiltered.push('users');
    }

    // Remover chaves que não existem no featuresSchema
    featuresFiltered = featuresFiltered.filter((feature: string) => 
      featuresSchema[feature]
    );
    
    // Ordenar por ordem definida no schema
    featuresFiltered = featuresFiltered.sort((a, b) => {
      return featuresSchema[a]?.order - featuresSchema[b]?.order;
    });

    return featuresFiltered;
  }

  static getFeatureSchema(): FeaturesSchema {
    return featuresSchema;
  }

  static buildFeatureUrl(account: Account, feature: string): string {
    const schema = featuresSchema[feature];
    
    if (schema?.items?.length > 0) {
      return '#'; // Para features com submenu
    }
    
    return `/${account.code}${schema?.url || ''}`;
  }

  static buildItemUrl(account: Account, itemUrl: string): string {
    return `/${account.code}${itemUrl}`;
  }

  static isItemActive(pathName: string, account: Account, itemUrl: string): boolean {
    return pathName === `/${account.code}${itemUrl}`;
  }

  static getActiveFeatureFromPath(pathName: string, account: Account): string {
    let activeFeature = '';
    
    Object.keys(featuresSchema).forEach((feature: string) => {
      const schema = featuresSchema[feature];
      
      if (schema?.items?.length > 0) {
        schema.items.forEach((item) => {
          if (`/${account.code}${item.url}` === pathName) {
            activeFeature = feature;
          }
        });
      } else {
        if (`/${account.code}${schema?.url}` === pathName) {
          activeFeature = feature;
        }
      }
    });

    return activeFeature;
  }

  static getDefaultFeatures(): string[] {
    return ['dashboard', 'reviews', 'users', 'treinos', 'social', 'communication'];
  }
}
